"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEWSLETTER_SATISFACTION_SURVEY_ID = exports.CAMPAIGN_GUEST_MONITORING_SURVEY_ID = exports.CAMPAIGN_PAYMENT_MONITORING_SURVEY_ID = exports.CAMPAIGN_SATISFACTION_SURVEY_ID = void 0;
exports.CAMPAIGN_SATISFACTION_SURVEY_ID = "campaignSatisfaction";
exports.CAMPAIGN_PAYMENT_MONITORING_SURVEY_ID = "paymentsMonitoring";
exports.CAMPAIGN_GUEST_MONITORING_SURVEY_ID = "guestsMonitoring";
exports.NEWSLETTER_SATISFACTION_SURVEY_ID = "newsletterSatisfaction";
